export default "__VITE_ASSET__BzkhZQAL__"